<template>
    <div>
        <section>
            <div class="container">
                <ol class="breadcrumb hidden-xs">
                    <li><a href="/">首頁</a></li>
                    <li><a href="#">加入聯盟</a></li>
                    <li class="active">填寫表單</li>
                </ol>
                <div class="row">
                    <div class="col-sm-3 hidden-xs">
                        <div class="row">
                            <div class="col-sm-12 col-xs-6" v-for="(row, index) in this.latest">
                                <div class="store_box">
                                    <router-link v-bind:to="'/store/'+row.comid">
                                        <figure class="img">
                                            <img v-if="row.com_image" v-bind:src="'https://files.i80.com.tw/images/product/'+row.com_image" class="img-responsive"/>
                                        </figure>
                                        <h5 class="title">{{row.com_name}}</h5>
                                        <h5 class="title">電話: {{row.com_phone}}</h5>
                                        <p class="txt">{{row.c_website}}</p>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-9 col-xs-12">
                        <h4 class="title">進駐商城</h4>
                        <p class="editor">
                            俗話說：「團結力量大」，現今台灣的消費者多數被財團剝削，將錢交到財閥手中，卻很少給消費者相對的回報。
                            假若我們將消費者集結起來，運用團結的力量，即可改變現狀。讓獲利回饋給消費者以及讓我們的聯盟商消費圈更鞏固，體現「取之於社會，用之於社會」的理念。
                        </p>
                        <p  class="editor">
                          雙方合作方式為，愛幫您提供系統平台服務，給予聯盟商產品上刊與介紹，以及依據聯盟商活躍程度，提供曝光版面，另提供系統服務協助以利於聯盟商發展。<br/><br/>
                          聯盟商加入上架費六萬八千元整，首次限時加入享優惠價三萬一千元整，若重新上架費為十三萬元整。
                          <strong>聯盟正式方案者，付款方式統一為 ATM 或 臨櫃付款</strong>
                          <br/><br/>
                          平台採預儲值系統最低金額以 10,000 元整，其儲值費用為聯盟商之產品成交時 發放回饋金抵扣之用，
                          於合約執行期間點數額保留於愛幫您系統中平台代為發放給會員。<br/>當需與平台解除合約時，必須繳清所有欠費（上架費、行銷費、資訊費）以及扣除愛幫您額外給予之補助與福利後可將餘款退回給聯盟商。<br/>
                          塡寫以下表單前，請先詳閱合約書，必要時可先下載紙本合約，一旦填寫，視為同意遵守合約條款的各項規定。
                          <a class="more" href="/static/files/agreement.pdf" target="_blank">合約下載</a>
                          <br/>
                          <br/>
                          若聯盟商家採用租賃模式(非一次繳清者)，則每月固定費用及單筆成交手續費做收取，使用負責人信用卡綁定進行款項收取。
                        </p>
                        <h4 class="title">進駐表單</h4>
                        <div class="apply_form">
                            <form class="form-horizontal">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="inputCo" class="col-sm-4 control-label input_required">公司/店面名稱</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="com_name" placeholder="公司/店面名稱" required>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="inputCoPhone" class="col-sm-4 control-label">公司電話</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="com_phone" maxlength="10" placeholder="公司電話">
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="inputUrl" class="col-sm-4 control-label">公司簡介</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="introduction" placeholder="公司簡介">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="inputCoNum" class="col-sm-4 control-label">統一編號</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="com_number" maxlength="10" placeholder="統一編號">
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="inputCoAdd" class="col-sm-4 control-label">地址</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="address" placeholder="公司/店面地址">
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="inputUrl" class="col-sm-4 control-label">網址</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="com_site" placeholder="官方網址">
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <hr/>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="inputConName" class="col-sm-4 control-label input_required">聯絡人姓名</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="contact_name" placeholder="聯絡人姓名" required>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="inputConPhone" class="col-sm-4 control-label input_required">聯絡人手機</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="contact_phone" maxlength="10" placeholder="聯絡人手機" required>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="inputEmail" class="col-sm-4 control-label">聯絡人信箱</label>
                                            <div class="col-sm-8">
                                                <input type="email" class="form-control" v-model="email" placeholder="聯絡人信箱" required>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="inputEmail" class="col-sm-4 control-label">密碼</label>
                                            <div class="col-sm-8">
                                                <input type="password" class="form-control" v-model="password" maxlength="20"  placeholder="請輸入您想要的密碼" required>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                      <div class="form-group">
                                          <label for="inputConPhone" class="col-sm-4 control-label input_required">負責人會員編號</label>
                                          <div class="col-sm-8">
                                              <input type="text" class="form-control" v-model="reliablemanid" placeholder="負責人會員編號" required>
                                          </div>
                                      </div>

                                        <div class="form-group">
                                            <label for="inputConPhone" class="col-sm-4 control-label input_required">商品類別</label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" v-model="productCategory" placeholder="填寫商品類別" required>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="inputConPhone" class="col-sm-4 control-label input_required">點數額</label>
                                            <div class="col-sm-8">
                                                <select class="form-control" v-model="pricing" required>
                                                    <option v-for="option in pricingList" v-bind:value="option.text">
                                                        {{option.text}} 元
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="text-center">
                                        <p class="">填寫表單前請先閲讀合約，一經填寫表單視同同意合約規定！並願意遵守！</p>
                                        <button type="button" class="btn btn-success" @click="apply()" :disabled="this.flag">我要加入</button>
                                    </div>
                                </div>
                                <hr/>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="inputConName" class="col-sm-4 control-label">31,000 聯盟首次優惠方案</label>
                                            <div class="col-sm-8">
                                              <a href="https://p.ecpay.com.tw/EA81824"><img src="https://payment.ecpay.com.tw/Content/themes/WebStyle20170517/images/ecgo.png" alt=""/></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="inputConName" class="col-sm-4 control-label">68,000 聯盟方案</label>
                                            <div class="col-sm-8">
                                              <a href="https://p.ecpay.com.tw/941A9AF"><img src="https://payment.ecpay.com.tw/Content/themes/WebStyle20170517/images/ecgo.png" alt=""/></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label for="inputConName" class="col-sm-4 control-label">130,000 聯盟方案</label>
                                              <a href="https://p.ecpay.com.tw/5799AAF"><img src="https://payment.ecpay.com.tw/Content/themes/WebStyle20170517/images/ecgo.png" alt=""/></a>
                                            <div class="col-sm-8">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: 'Apply',
  data () {
    return {
      apiurl: 'https://affiliate.i80.com.tw/api',
      com_name: '',
      com_phone: '',
      contact_name: '',
      email: '',
      password: '',
      com_number: '',
      address: '',
      contact_phone: '',
      com_site: '',
      latest: '',
      productCategory: '',
      introduction: '',
      reliablemanid: 0,
      pricing: 10000,
      flag: false,
      pricingList: [
        { text: '10000', value: 10000 },
        { text: '20000', value: 20000 },
        { text: '30000', value: 30000 },
        { text: '40000', value: 40000 },
        { text: '50000', value: 50000 }
      ]
    }
  },
  mounted: function () {
    this.$http.get(this.apiurl + '/latestAffiliate').then(function (res) {
      this.latest = res.body.data
      // console.log(data.order)
    }, function () {
      console.log('failed')
    })
  },
  methods: {
    apply () {
      let str = ''
      if (!this.com_name) {
        str += '請填寫廠商名稱。\n'
      } else if (!this.com_phone) {
        str += '請先填寫聯絡電話。\n'
      } else if (this.contact_name === '') {
        str += '請先填寫聯絡人姓名。\n'
      } else if (this.email === '') {
        str += '請先填寫電子信箱。\n'
      } else if (this.password === '') {
        str += '請先填密碼。\n'
      } else if (this.pricing === '') {
        str += '請選擇上架費金額。\n'
      }

      const rulename = new RegExp('^[\u4e00-\u9fa5_a-zA-Z]+$')
      if (!rulename.test(this.contact_name)) {
        str += '您的姓名只能輸入中文或英文。'
      }

      const rulphone = new RegExp('^[09]{2}[0-9]{8}$')
      if (!rulphone.test(this.contact_phone)) {
        str += '您輸入聯絡人手機不正確。'
      }
      const ruleEmail = new RegExp(/^[^\s]+@[^\s]+\.[^\s]+$/)
      if (!ruleEmail.test(this.email)) {
        str += '您輸入的Email不正確。'
      }
      if (str === '') {
        this.flag = true
        this.$http.post('https://affiliate.i80.com.tw/api/addAffiliate', {
          com_email: this.email,
          com_name: this.com_name,
          c_website: this.com_site,
          com_number: this.com_number,
          com_reliableman: this.contact_name,
          com_phone: this.com_phone,
          com_contact_phone: this.contact_phone,
          com_address: this.address,
          introduction: this.introduction,
          productCategory: this.productCategory,
          password: this.password,
          pricing: this.pricing,
          reliablemanid: this.reliablemanid
        }).then(function (res) {
          let status = res.body.status
          if (status === 200) {
            window.alert('申請成功，我們將盡快為您處理。')
            // location.reload()
          } else {
            window.alert('申請失敗，請重新申請。')
          }
          // console.log(res.body)
        }, function () {
          console.log('failed')
        })
      } else {
        window.alert(str)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Apply.vue?243e1dff